import PropTypes from "prop-types";
import { Chip, Divider } from "@mui/material";

const styles = {
  divider: { paddingTop: "4px", paddingBottom: "4px" },
};

export default function MyDivider(props) {
  const size = props.size || "medium";
  let gutterHeight = props.gutterHeight ? props.gutterHeight : "18px";
  // if gutterHeight is a number make it a string with px
  if (typeof gutterHeight === "number") gutterHeight += "px";
  else if (!gutterHeight.includes("px")) gutterHeight += "px";

  const noPrint = props.noPrint || false;
  const gutter = props.gutter || false;

  let height = props.height || "100%";
  if (height < 13) height = 13;

  let rows = props.rows || 1;
  if (rows < 1) rows = 1;

  if (!gutter) {
    gutterHeight = "0px";
  }

  return (
    <div className={noPrint ? "noPrint" : ""} style={{ width: "100%" }}>
      {
        //define minimum height for the div
      }
      {size === "medium" && <div style={{ height: height ? (height - 12) / 2 + "px" : "100%" }} />}

      {
        // if gutter or gutterTop is true the add a div with height of gutterHeight
      }
      {size === "medium" && (gutter || props.gutterTop) && <div style={{ height: gutterHeight }} />}

      {
        // if chipText or children is defined then render the divider with chipText or children
        // if rows is defined then render the divider with chipText or children
        // rows is the number of dividers to render, max number of rows: 7
      }
      {props.chipText || props.children ? (
        <>
          {rows > 5 && <Divider sx={styles.divider} />}
          {rows > 3 && <Divider sx={styles.divider} />}
          {rows > 1 && <Divider sx={styles.divider} />}
          <Divider sx={styles.divider}>
            {props.chipText && <Chip label={props.chipText} />}
            {props.children && props.children}
          </Divider>
          {rows > 2 && <Divider sx={styles.divider} />}
          {rows > 4 && <Divider sx={styles.divider} />}
          {rows > 6 && <Divider sx={styles.divider} />}
        </>
      ) : (
        <>
          {Array(rows)
            .fill()
            .map((r, i) => (
              <Divider key={i} sx={styles.divider} />
            ))}
        </>
      )}

      {
        // if gutter or gutterBottom is true the add a div with height of gutterHeight
      }
      {size === "medium" &&
        (gutter || props.gutterBottom) && ( // if gutter or gutterBottom is true the add a div with height of gutterHeight
          <div style={{ height: gutterHeight }} />
        )}
      {
        //define minimum height for the div
      }
      {size === "medium" && (
        <div
          style={{
            height: props.height ? (props.height - 12) / 2 + "px" : "100%", // if height is defined then use it, else use 100%
          }}
        />
      )}
    </div>
  );
}

MyDivider.propTypes = {
  height: PropTypes.number,
  gutter: PropTypes.bool,
  gutterTop: PropTypes.bool,
  gutterBottom: PropTypes.bool,
  children: PropTypes.node,
  chipText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  noPrint: PropTypes.bool,
  gutterHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rows: PropTypes.number,
  size: PropTypes.string,
};
